'use server'
import { createClient } from '@/lib/supabase/server'
import { redirect } from 'next/navigation'

export async function signInAction(
  email: string,
  password: string,
): Promise<{ error: string } | never> {
  const supabase = await createClient()

  const { data, error } = await supabase.auth.signInWithPassword({ email, password })

  if (error) {
    return { error: error.message }
  }

  const { data: profile } = await supabase
    .from('profiles')
    .select('role')
    .eq('id', data.user.id)
    .single()

  const role = profile?.role

  if (role === 'student') redirect('/student/dashboard')
  else if (role === 'facilitator') redirect('/facilitator/dashboard')
  else if (role === 'partner_admin') redirect('/partner/dashboard')
  else return { error: 'Unknown account role. Please contact support.' }
}
